// Components
import { InfoCard } from '@/components/common';
import DownloadCard from './DownloadCard/DownloadCard';
// Hooks
import { useWebiny } from '@/providers/WebinyProvider';
// Styles
import styles from './dashboard-nodes.module.css';

const ERROR_TEXT = `Network request timed out. Please refresh your browser.`;

export default function DashboardNodes({ error, loading, nodeState }) {
  const { smartNodeCard, liteNodeCard } = useWebiny();
  const infoCardText = (text) =>
    error ? ERROR_TEXT : loading ? 'Loading...' : `${text}`;

  return (
    <div className={styles.nodesContainer}>
      <InfoCard
        showToolTip
        amountOne={nodeState?.smartNodesOnline}
        amountText={infoCardText(smartNodeCard.subTitle)}
        amountTwo={nodeState?.smartLicensesOwned}
        dataTag="vaultNodeSmart"
        error={error}
        headingText={smartNodeCard.title}
        loading={loading}
        tooltipHeading={smartNodeCard.toolTip.title}
        tooltipText={smartNodeCard.toolTip.helpText}
        type="smart"
      />
      <InfoCard
        showToolTip
        amountOne={nodeState?.liteNodesOnline}
        amountText={infoCardText(liteNodeCard.subTitle)}
        amountTwo={nodeState?.liteLicensesOwned}
        dataTag="vaultNodeLite"
        error={error}
        headingText={liteNodeCard.title}
        loading={loading}
        tooltipHeading={liteNodeCard.toolTip.title}
        tooltipText={liteNodeCard.toolTip.helpText}
        type="lite"
      />
      <DownloadCard />
    </div>
  );
}
